module.exports = __webpack_public_path__ + "img/icon_historial_verde.035e5e0a.svg";